<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="size" :height="size">
    <title>{{ title }}</title>
    <g :fill="fill">
      <path
        d="M38,15H27.326l3.636-12.725c0.086-0.302,0.026-0.626-0.163-0.877S30.314,1,30,1H16 c-0.451,0-0.846,0.302-0.965,0.737l-6,22c-0.082,0.301-0.019,0.623,0.17,0.87C9.395,24.854,9.688,25,10,25h10.802l-3.786,20.821 c-0.085,0.466,0.169,0.928,0.609,1.106C17.748,46.977,17.875,47,18,47c0.327,0,0.643-0.16,0.833-0.445l20-30 c0.205-0.307,0.224-0.701,0.05-1.026C38.708,15.203,38.369,15,38,15z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 14,
    },
    title: {
      type: String,
      default: "Flash"
    },
    fill: {
      type: String,
      default: "currentColor"
    },
  },
}
</script>
